import styled from 'styled-components'

export default styled.div`
  padding-left: 2.34375vw;
  padding-right: 2.34375vw;
  padding-top: 1.7vw;
  padding-bottom: 2.34375vw;
  color: #${props => props.color};
  /* background-color: ${props => (props.bg === 'dark' ? '#374047' : 'white')}; */
  background-color: #${props => (props.bg ? props.bg : 'FFF')};

  @media  (max-width: 40em) {
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
`
